import React from 'react';
import { PlayCircle } from '@mui/icons-material';
import { Box } from '@mui/material';

export interface GalleryVideoProps {
  /**
   * The video source URL
   */
  src: string;
  /**
   * Alt text for accessibility
   */
  alt?: string;
  /**
   * Width of the video container
   */
  width?: string | number;
  /**
   * Height of the video container
   */
  height?: string | number;
  /**
   * Max width constraint
   */
  maxWidth?: string;
  /**
   * Max height constraint
   */
  maxHeight?: string;
  /**
   * CSS object-fit property
   */
  objectFit?: 'cover' | 'contain';
  /**
   * Border radius
   */
  borderRadius?: string;
  /**
   * Whether to show play icon overlay
   */
  showPlayIcon?: boolean;
  /**
   * Size of play icon in pixels
   */
  playIconSize?: number;
}

/**
 * GalleryVideo displays a video thumbnail with a play icon overlay
 * Used in galleries to indicate playable video content
 */
export const GalleryVideo: React.FC<GalleryVideoProps> = ({
  src,
  width = '100%',
  height = '100%',
  maxWidth,
  maxHeight,
  objectFit = 'cover',
  borderRadius = '8px',
  showPlayIcon = true,
  playIconSize = 64,
}) => {
  return (
    <>
      <video
        src={src}
        style={{
          width,
          height,
          maxWidth,
          maxHeight,
          objectFit,
          display: 'block',
          borderRadius,
        }}
        preload="metadata"
      >
        <track kind="captions" />
      </video>
      {showPlayIcon && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
          }}
        >
          <PlayCircle
            sx={{
              fontSize: `${playIconSize}px`,
              color: 'rgba(255, 255, 255, 0.9)',
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))',
            }}
          />
        </Box>
      )}
    </>
  );
};
